import { createSvgIcon } from "@mui/material/utils";

const WorldRankingIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Picto_OK_2">
      <g id="Group">
        <path
          id="Vector"
          d="M12.0424 0.169556C5.51237 0.169556 0.169617 5.51231 0.169617 12.0423C0.169617 18.5724 5.51237 23.9151 12.0424 23.9151C18.5724 23.9151 23.9152 18.5724 23.9152 12.0423C23.9152 5.51231 18.5724 0.169556 12.0424 0.169556ZM21.4558 12.0423C21.4558 13.9081 20.8622 15.689 19.9293 17.1307L17.5548 8.14129L19.5053 6.19076C20.6926 7.80207 21.4558 9.8374 21.4558 12.0423ZM2.54418 12.0423C2.54418 11.6183 2.54418 11.1943 2.62898 10.7703L11.0247 12.9752L11.8728 16.0282L2.71379 13.6537C2.62898 13.06 2.54418 12.5512 2.54418 12.0423ZM11.6184 10.6855L8.56538 9.8374L15.265 3.13775C16.1979 3.47698 16.9611 3.90101 17.7244 4.49464L11.6184 10.6855ZM13.3993 12.3816L15.6042 10.1766L18.0636 19.3356C17.3004 19.9293 16.5371 20.4381 15.6042 20.7773L13.3993 12.3816ZM12.0424 2.54411C12.212 2.54411 12.2968 2.54411 12.4664 2.54411L5.9364 9.15896L3.30743 8.48051C4.66432 5.00348 8.05654 2.54411 12.0424 2.54411ZM3.64665 16.3674L12.636 18.742L13.3145 21.371C12.8905 21.4558 12.4664 21.4558 12.0424 21.4558C8.39577 21.4558 5.17315 19.4204 3.64665 16.3674Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>,
  "WorldRankingIcon"
);

const MatchProbIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Picto_OK_2">
      <g id="Group">
        <path
          d="M24 16.5371L22.4735 14.6714L21.6254 15.3498V0H0V24H2.37456V15.1802H19.2509V17.3852L14.2473 21.5406L12.4664 20.0141L10.9399 21.8799L13.4841 24H15.0106L19.2509 20.4382V24H21.6254V18.4028L24 16.5371ZM19.2509 6.36042H15.265V2.37456H19.2509V6.36042ZM8.81979 6.36042V2.37456H12.8905V6.36042H8.81979ZM12.8905 8.81979V12.8057H8.81979V8.81979H12.8905ZM6.44523 2.37456V6.36042H2.37456V2.37456H6.44523ZM2.37456 8.81979H6.36042V12.8057H2.37456V8.81979ZM15.265 12.8057V8.81979H19.2509V12.8057H15.265ZM9.41343 20.6078C8.22615 20.6078 7.29329 19.6749 7.29329 18.4876C7.29329 17.3004 8.22615 16.3675 9.41343 16.3675C10.6007 16.3675 11.5336 17.3004 11.5336 18.4876C11.5336 19.6749 10.6007 20.6078 9.41343 20.6078Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>,
  "MatchProbIcon"
);

const RankingProbIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Picto_OK_2">
      <g id="Group">
        <path
          d="M23.6608 12.0424C23.6608 5.59722 18.4028 0.424072 12.0424 0.424072C5.68199 0.424072 0.339233 5.59722 0.339233 12.0424C0.339233 18.4877 5.59719 23.6608 11.9576 23.6608C14.6714 23.6608 17.2156 22.728 19.1661 21.1167L21.2862 23.3216L22.9823 21.6255L20.8622 19.4205C22.6431 17.3852 23.6608 14.841 23.6608 12.0424ZM12.0424 21.2863C6.95408 21.2863 2.7986 17.1308 2.7986 12.0424C2.7986 6.95411 6.95408 2.79863 12.0424 2.79863C17.1308 2.79863 21.2862 6.95411 21.2862 12.0424C21.2862 14.1626 20.523 16.1979 19.3357 17.7244L13.3145 11.5336V5.00358H10.9399V12.0424L11.2792 12.8905L17.7244 19.4205C16.0283 20.523 14.0778 21.2863 12.0424 21.2863Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>,
  "RankingProbIcon"
);

const HealthCheckIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Picto_OK_2">
      <g id="Group">
        <path
          d="M11.0248 18.0636H9.24384L4.57953 12.8056L6.36045 11.1943L10.0919 15.4346L18.9965 5.51233L20.7774 7.12364L11.0248 18.0636Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>,
  "HealthCheckIcon"
);

const MethodologyIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Picto_OK_2">
      <g id="Group">
        <path
          d="M4.15545 24L3.13778 23.4064L0.254389 18.6572L0.0847778 18.0636V1.18728L1.27206 0H17.2155L18.4028 1.18728V16.7915H22.8975L24 18.5724L21.2014 24H19.0812L16.4523 19.2509H4.49467V16.8763H16.0282V2.45936H2.54414V17.7244L4.9187 21.6254H16.113V24H4.15545ZM19.2509 19.2509L20.0989 20.8622L20.947 19.2509H19.2509Z"
          fill="currentColor"
        />
        <path
          d="M13.9929 12.8905H4.49469V15.2651H13.9929V12.8905Z"
          fill="currentColor"
        />
        <path
          d="M13.9929 8.90454H4.49469V11.2791H13.9929V8.90454Z"
          fill="currentColor"
        />
        <path
          d="M13.9929 4.9187H4.49469V7.29326H13.9929V4.9187Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>,
  "MethodologyIcon"
);

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

/** External (restricted) users must not see these dashboard entries. */
const MENU_ITEM_IDS_HIDDEN_FOR_RESTRICTED = new Set([
  "match-probabilities",
  "health-check",
]);

const navGroup = {
  id: "fivb-nav-bar",
  type: "group",
  title: "FIVB NAV BAR",
  children: [
    {
      id: "world-ranking",
      title: "WORLD RANKING",
      type: "item",
      url: "/world-ranking",
      icon: WorldRankingIcon,
      breadcrumbs: false,
    },
    {
      id: "match-probabilities",
      title: "MATCH PROBABILITIES",
      type: "item",
      url: "/match-probabilities",
      icon: MatchProbIcon,
      breadcrumbs: false,
    },
    {
      id: "ranking-probabilities",
      title: "RANKING PROBABILITIES",
      type: "item",
      url: "/ranking-probabilities",
      icon: RankingProbIcon,
      breadcrumbs: false,
    },
    {
      id: "health-check",
      title: "HEALTH CHECK",
      type: "item",
      url: "/health-check",
      icon: HealthCheckIcon,
      breadcrumbs: false,
    },
    {
      id: "ranking-explained",
      title: "RANKING EXPLAINED",
      type: "item",
      url: "/ranking-explained",
      icon: MethodologyIcon,
      breadcrumbs: false,
    },
  ],
};

/**
 * @param {boolean} isRestricted - User is in REACT_APP_RESTRICTED_GROUP_ID (External).
 */
export function getNavGroupForUser(isRestricted) {
  if (!isRestricted) return navGroup;
  return {
    ...navGroup,
    children: navGroup.children.filter(
      (c) => !MENU_ITEM_IDS_HIDDEN_FOR_RESTRICTED.has(c.id)
    ),
  };
}

export default navGroup;
